import { IEvent } from "@Interfaces";
import { CURRENCY_STRINGS, CURRENCY_SYMBOLS } from "repoV2/constants/payment";

export const getEventCurrency = ({
    eventData,
}: {
    eventData?: IEvent.IEventData;
}) => {
    return {
        eventCurrencySymbol: eventData?.currency || CURRENCY_SYMBOLS.INR,
        eventCurrency: eventData?.currency_name || CURRENCY_STRINGS.INR,
    };
};
